
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import PageHeading from "@/components/PageHeading.vue";
import { ViewAnalytics } from "@/mixins";
import { ApiService, LogService, RouterService, SnackbarService } from "@/services";
import { ApplicationModule, getStoreModule, SessionModule } from "@/store";
import { MetadataKeys, User, VignetteRoutes } from "@/types";

@Component({
  components: {
    PageHeading,
  },
})
export default class AssignedUsers extends mixins(ViewAnalytics) {
  private applicationStore!: ApplicationModule;
  private sessionStore!: SessionModule;
  private sessionInfo!: User;

  private assignedUsersList: string[] = [];
  private isAddingNewEmail = false;
  private newEmail = "";

  // Override for PageTitle mixin
  pageName = "Assigned Users";

  created(): void {
    this.applicationStore = getStoreModule(ApplicationModule, this.$store);
    this.sessionStore = getStoreModule(SessionModule, this.$store);

    this.sessionInfo = this.sessionStore.getUser;

    // TODO: handle within router?
    if (
      this.sessionInfo != null &&
      (this.sessionInfo.accountOrganization.hasUnlimitedSeats || !this.sessionInfo.isVignetteUserManager)
    ) {
      LogService.warn("AssignedUsers.vue: non-user manager / unlimited seat account tried to access the page.");
      RouterService.navigateByName(this.$router, VignetteRoutes.MyAccount);

      return;
    }

    if (this.sessionInfo != null) {
      ApiService.getUserManagement().then(() => {
        // TODO: handle response msg if error / list isn't loaded.
        this.assignedUsersList = this.applicationStore.getAssignedUsersList;
      });
    } else {
      LogService.warn("AssignedUsers.vue: user session is not available");
    }
  }

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Account Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "My Account");
    this.pushPageViewEvent();
  }

  get seatsAllowed(): number {
    return this.sessionInfo?.accountOrganization.seatsAllowed || 0;
  }

  get seatsAvailable(): number {
    // TODO: This logic is duplicated in MyAccount.vue, we can move it into app store?
    const available = this.seatsAllowed - this.assignedUsersList.length;
    if (available < 0) {
      LogService.error(`AssignedUsers.vue: error calculating seatsAvailable, available: ${available}`);
      return 0;
    }
    return available;
  }

  get myAccountRoute(): VignetteRoutes {
    return VignetteRoutes.MyAccount;
  }

  clickSave(): void {
    if (this.newEmail.length > 0) {
      ApiService.putUserManagement(this.newEmail, "add").then((response) => {
        LogService.info(`statusMsg: ${response}`);
        if (!response || response.indexOf("ok") == 0) {
          this.assignedUsersList = this.applicationStore.getAssignedUsersList;
          this.clearInput();
          LogService.info("AssignedUsers.vue: Email saved.");
        } else {
          SnackbarService.displaySnackbar(response);
        }
      });
    }
  }

  removeUser(user: string): void {
    ApiService.putUserManagement(user, "remove").then((response) => {
      if (!response || response.indexOf("ok") == 0) {
        this.assignedUsersList = this.applicationStore.getAssignedUsersList;
        this.clearInput();
        LogService.info(`UserManagement.vue: Successfully removed user '${user}'`);
      } else {
        LogService.warn(`UserManagement.vue: removeUser status: ${response}`);
        SnackbarService.displaySnackbar(response);
      }
    });
  }

  clearInput(): void {
    this.isAddingNewEmail = false;
    this.newEmail = "";
  }
}
